module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/baccarat-4711b2d468abad0a.jpg"+" 536w",
        images: [{path: __webpack_public_path__ + "assets/images/baccarat-4711b2d468abad0a.jpg",width: 536,height: 560}],
        src: __webpack_public_path__ + "assets/images/baccarat-4711b2d468abad0a.jpg",
        toString: function(){return __webpack_public_path__ + "assets/images/baccarat-4711b2d468abad0a.jpg"},
        
        width: 536,
        height: 560
      }